<template>
  <div>
    <Card shadow>
      <Row :gutter="16" style="margin-top: 12px">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 120px">标签类型:</span>
            <Select
              placeholder="标签类型"
              v-model="table.params.tag_type"
              clearable
              filterable
              @on-change="SearList"
            >
              <Option
                v-for="item in select.tag_type_list"
                :value="item.value"
                :key="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="3">
          <Button type="primary" icon="md-refresh" @click="reloadSingle"
            >刷新</Button
          >
        </Col>
        <Col span="4" offset="13">
          <Button type="primary" style="float: right" @click="OpenModal1('add')"
            >添加配置</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      style="margin-top: 12px;"
      border
      :max-height="tableMaxHeight"
      :ref="table.ref"
      :columns="table.columns"
      :data="table.data"
      @on-selection-change="SelectRow"
    />
    <Page
      show-total
      show-sizer
      style="margin-top: 12px; margin-bottom: 12px;"
      :page-size="table.params.page_size"
      :total="table.page_total"
      :current="table.page_current"
      @on-change="ChangePage"
      @on-page-size-change="ChangePageSize"
    />
    <!-- 新增和编辑 -->
    <Modal v-model="modal1.show" @on-cancel="CloseModal1">
      <div slot="header">
        {{ modal1.type == 'add' ? '新增' : '修改' }} 标签配置
      </div>
      <Form
        :ref="modal1.form.ref"
        :model="modal1.form.data"
        :rules="modal1.form.rules"
        :label-width="120"
      >
        <Row>
          <Col span="20">
            <FormItem label="标签类型" prop="tag_type">
              <Select
                placeholder="标签类型"
                v-model="modal1.form.data.tag_type"
              >
                <Option
                  v-for="item in select.tag_type_list"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="标签名字" prop="tag">
              <Input type="text" v-model="modal1.form.data.tag" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="展示标签名" prop="tag_name">
              <Input type="text" v-model="modal1.form.data.tag_name" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="标签优先级" prop="level">
              <InputNumber
                style="width: 100%"
                v-model="modal1.form.data.level"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
      </Form>

      <div slot="footer">
        <Button type="primary" @click="Update">提交</Button>
      </div>
    </Modal>

    <!-- 复制标签类型-->
    <Modal v-model="copy_modal.show">
      <div slot="header">复制标签配置</div>
      <Form
        :ref="copy_modal.form.ref"
        :model="copy_modal.form.data"
        :rules="copy_modal.form.rules"
        :label-width="120"
      >
        <Row>
          <Col span="20">
            <FormItem label="标签类型">
              <Select
                placeholder="标签类型"
                disabled
                v-model="copy_modal.form.data.tag_type"
              >
                <Option
                  v-for="item in select.tag_type_list"
                  :value="item.value"
                  :key="item.value"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="标签名字" prop="tag">
              <Input type="text" v-model="copy_modal.form.data.tag" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="展示标签名" prop="tag_name">
              <Input type="text" v-model="copy_modal.form.data.tag_name" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="20">
            <FormItem label="标签优先级" prop="level">
              <InputNumber
                style="width: 100%"
                v-model="copy_modal.form.data.level"
              ></InputNumber>
            </FormItem>
          </Col>
        </Row>
      </Form>

      <div slot="footer">
        <Button type="primary" @click="updateCopy">提交</Button>
      </div>
    </Modal>
    <!-- 策略关联详情 -->
    <Modal v-model="risk_modal.show" @on-cancel="CloseModal1" width="800">
      <div slot="header">策略关联详情</div>
      <Table
        style="margin-top: 12px"
        border
        :columns="risk_modal.table.columns"
        :data="risk_modal.table.data"
      />
      <div slot="footer">
        <Button type="primary" @click="rogo(1)">跳转策略配置库</Button>
      </div>
    </Modal>
    <!-- 智能风控 -->
    <Modal
      v-model="intelligent_modal.show"
      @on-cancel="CloseModal1"
      width="800"
    >
      <div slot="header">策略关联详情</div>
      <Table
        style="margin-top: 12px"
        border
        :columns="intelligent_modal.table.columns"
        :data="intelligent_modal.table.data"
      />
      <div slot="footer">
        <Button type="primary" @click="rogo(2)">跳转策略配置库</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  GetAppTagList,
  UpdateAppTagList,
  BatchAppTagList,
  CopyAppTag,
  GetGameRiskList,
  GetSmartRiskList
} from '@/api/admin/risk'
import { Component, Vue, Watch } from 'vue-property-decorator'
@Component
export default class riskTagLibConf extends Vue {
  select = {
    app_list: [],
    tag_type_list: [
      { value: 'risk_tag', name: '游戏风控标签' },
      { value: 'smart_tag', name: '智能风控标签' },
      // { value: 'sms_tag', name: '短信标签' }
    ],
    stock_period_list: [
      { value: 2, name: '天库存' },
      { value: 3, name: '周库存' },
      { value: 4, name: '月库存' }
    ]
  }
  // 列表最大高度
  tableMaxHeight = 0;
  table = {
    ref: 'table',
    params: { sale_type: -1, page: 1, page_size: 10 },
    columns: [
      { type: 'index', title: '序号', width: 100, align: 'center' },
      { title: 'ID', key: 'id', width: 100, align: 'center' },
      {
        title: '标签类型',
        width: 240,
        resizable: true,
        align: 'center',
        render: (h, params) =>
          h(
            'div',
            this.select.tag_type_list.filter(
              v => v.value == params.row.tag_type
            )[0].name
          ),
        // filters: [
        //   { value: 'risk_tag', label: '游戏风控标签' },
        //   { value: 'smart_tag', label: '智能风控标签' },
        //   { value: 'sms_tag', label: '短信标签' }
        // ],
        // filterMultiple: true,
        // filterMethod(value, row) {
        //   return row.tag_type == value
        // }
      },
      {
        title: '标签名字',
        key: 'tag',
        width: 240,
        resizable: true,
        align: 'center'
      },
      {
        title: '展示标签名',
        key: 'tag_name',
        width: 240,
        resizable: true,
        align: 'center'
      },
      { title: '标签优先级', key: 'level', width: 240, align: 'center' },
      {
        title: '管理策略数量',
        key: 'stock_count',
        width: 240,
        resizable: true,
        align: 'center',
        render: (h, params) => {
          return h('div', [
            h(
              'a',
              {
                on: {
                  click: () => {
                    this.risk_modal.tag = params.row.id
                    this.intelligent_modal.tag = params.row.id
                    if (params.row.stock_count) {
                      this.getGameRiskList(params.row.id, params.row.tag_type)
                    }
                  }
                }
              },
              params.row.stock_count
            )
          ])
        }
      },
      {
        fixed: this.isMOble() ? '' : 'right',
        title: '操作',
        align: 'center',
        minWidth: 300,
        render: (h, params) => {
          return h('div', [
            h(
              'Button',
              {
                props: { type: 'info' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.OpenModal1('edit', params.row)
                  }
                }
              },
              '编辑'
            ),
            h(
              'Button',
              {
                props: { type: 'primary' },
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.copy_modal.form.data['old_id'] = params.row.id
                    this.copy_modal.form.data['tag_type'] = params.row.tag_type
                    this.copy_modal.form.data['tag_name'] = params.row.tag_name
                    this.copy_modal.form.data['tag'] = params.row.tag
                    // this.copy_modal.form.data["level"] = params.row.level;
                    this.copy_modal.show = true
                  }
                }
              },
              '复制标签及策略'
            ),
            h(
              'Button',
              {
                props: { type: 'error' },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认删除',
                      onOk: () => {
                        this.Delete(params.row.id)
                      }
                    })
                  }
                }
              },
              '删除'
            )
          ])
        }
      }
    ],
    data: [],
    sel_datas: [],
    sel_ids: [],
    page_total: 1,
    page_current: 1
  }
  //修改添加风控
  modal1 = {
    show: false,
    type: 'add',
    form: {
      ref: 'modal1_form',
      data: { level: 0 },
      rules: {
        tag_type: [
          {
            required: true,
            trigger: 'change',
            validator: this.simpleVerify(new Error('请选择标签类型'))
          }
        ],
        tag: [
          {
            required: true,
            trigger: 'blur',
            validator: this.simpleVerify(new Error('请输入标签名字'))
          }
        ],
        tag_name: [
          {
            required: true,
            trigger: 'blur',
            validator: this.simpleVerify(new Error('请输入展示标签名'))
          }
        ]
      }
    }
  }
  //复制风控策略
  copy_modal = {
    show: false,
    form: {
      ref: 'copy_modal_form',
      data: {
        old_id: 0,
        tag_type: '',
        tag: '',
        tag_name: '',
        level: 0
      },
      rules: {
        tag_type: [
          {
            required: true,
            trigger: 'change',
            validator: this.simpleVerify(new Error('请选择标签类型'))
          }
        ],
        tag: [
          {
            required: true,
            trigger: 'blur',
            validator: this.simpleVerify(new Error('请输入标签名字'))
          }
        ],
        tag_name: [
          {
            required: true,
            trigger: 'blur',
            validator: this.simpleVerify(new Error('请输入展示标签名'))
          }
        ]
      }
    }
  }
  // 策略关联详情
  risk_modal = {
    show: false,
    table: {
      data: [],
      columns: [
        { type: 'index', title: '序号', width: 50, align: 'center' },
        { title: '策略ID', key: 'id', minWidth: 50, align: 'center' },
        { title: '风控名称', key: 'risk_name', minWidth: 50, align: 'center' },
        {
          title: '风控类型/风控方式',
          key: 'risk_mode',
          minWidth: 50,
          align: 'center',
          render: (h, params) => {
            let arr = [
              '系统自动风控',
              '持续开启杀风控',
              '持续开启送风控',
              '关闭风控，累加库存'
            ]
            return h('div', [
              h('span', arr[params.row.sys_type]),
              h('span', { style: { margin: '0 2px' } }, '/'),
              h(
                'span',
                {
                  style: {
                    color: `${['#2db7f5', '#ff9900'][params.row.risk_mode]}`
                  }
                },
                ['库存盈亏', '营收比'][params.row.risk_mode]
              )
            ])
          }
        },
        {
          title: '库存周期',
          key: 'stock_period',
          minWidth: 50,
          align: 'center',
          render: (h, params) =>
            h(
              'div',
              this.select.stock_period_list.filter(
                item => item.value == params.row.stock_period
              )[0].name
            )
        },
        {
          title: '风控概率',
          key: 'risk_rate',
          minWidth: 50,
          align: 'center',
          render: (h, params) => h('div', params.row.risk_rate + '%')
        }
      ]
    },
    tag: 0
  }
  //智能风控
  intelligent_modal = {
    show: false,
    table: {
      data: [],
      columns: [
        { type: 'index', title: '序号', width: 50, align: 'center' },
        // { type: 'selection', title: 'ID', key: 'id', fixed: 'left', width: 50 },
        { title: '编号', key: 'id', width: 90, align: 'center' },
        {
          title: '风控类型',
          width: 180,
          resizable: true,
          align: 'center',
          render: (h, params) => {
            return h(
              'div',
              {
                style: `color:${['blue', '#19be6b'][params.row.ctype]}`
              },
              ['执行风控策略', '玩家风控属性'][params.row.ctype]
            )
          }
        },
        {
          title: '标签',
          key: 'tag',
          width: 180,
          resizable: true,
          align: 'center',
          render: (h, params) => {
            let arr = []
            /*let app_info = this.select.smart_tag_list.filter((v) => v.value == params.row.tag)[0];

                        if (app_info) {
                            arr.push(h('span', app_info.name), h('span', { style: 'color:#bbb' }, `（${app_info.value}）`));
                        }*/

            return h('div', arr)
          }
        },
        {
          title: '名称',
          key: 'name',
          width: 180,
          resizable: true,
          align: 'center'
        },
        {
          title: '描述',
          key: 'reason',
          width: 180,
          resizable: true,
          align: 'center'
        },
        {
          title: '最大执行次数',
          key: 'succ_max',
          width: 180,
          resizable: true,
          align: 'center',
          render: (h, params) => {
            let arr = []
            arr.push(
              h('p', [
                h('span', '非捕鱼类'),
                h(
                  'span',
                  { style: 'color:#ed4014;' },
                  `  (${params.row.succ_max})`
                )
              ]),
              h('p', [
                h('span', '捕鱼类'),
                h(
                  'span',
                  { style: 'color:#ed4014;' },
                  `  (${params.row.fish_succ_max})`
                )
              ])
            )

            return h('div', arr)
            // return h("div",
            //     {style: `color:${["#ed4014", "#19be6b"][params.row.status]}`},["关闭", "开启"][params.row.status]
            // );
          }
        },
        {
          title: '排序',
          key: 'sorts',
          width: 180,
          resizable: true,
          align: 'center',
          sortable: true,
          sortMethod: function(a, b, type) {}
        },
        {
          title: '状态',
          width: 180,
          resizable: true,
          align: 'center',
          render: (h, params) =>
            h(
              'div',
              { style: `color:${['#ed4014', '#19be6b'][params.row.status]}` },
              ['关闭', '开启'][params.row.status]
            ),
          filters: [
            { value: 0, label: '关闭' },
            { value: 1, label: '开启' }
          ],
          filterMultiple: false,
          filterMethod(value, row) {
            return row.status == value
          }
        },
        {
          title: '最后修改时间',
          key: 'updated_time',
          width: 180,
          resizable: true,
          align: 'center',
          sortable: true,
          sortMethod: function(a, b, type) {}
        }
      ]
    },
    tag: 0
  }
  reloadSingle() {
    this.GetList()
  }
  GetList() {
    GetAppTagList({ ...this.table.params }).then(res => {
      let data = res._param
      this.table.data = data.List || []
      this.table.page_total = data.total
    })
  }
  ChangePage(page) {
    this.table.params.page = page
    this.table.page_current = page
    this.GetList()
  }
  ChangePageSize(page_size) {
    this.table.params.page = 1
    this.table.page_current = 1
    this.table.params.page_size = page_size
    this.GetList()
  }
  SelectRow(selection) {
    this.table.sel_datas = []
    this.table.sel_ids = []
    selection.map(item => {
      this.table.sel_datas.push(item)
      this.table.sel_ids.push(item.id)
    })
  }
  SearList() {
    this.table.params.page = 1
    this.$refs[this.table.ref].currentPage = 1
    this.table.page_current = 1
    this.GetList()
  }
  Delete(id) {
    if (id) {
      let params = { action: 1, ids: [id] }
      BatchAppTagList(params).then(res => {
        this.GetList()
      })
    } else {
      let data_list = this.table.sel_ids
      let params = { ids: data_list }
      this.$Modal.confirm({
        title: '确认删除',
        content: `确认删除 <span style="color:red">${data_list.length}</span> 条记录`,
        onOk: () => {}
      })
    }
  }

  // 编辑和新增
  OpenModal1(type, row = {}) {
    this.modal1.show = true
    this.modal1.type = type
    this.modal1.form.data = { id: 0, level: 0, ...row }
  }
  CloseModal1() {
    this.$refs[this.modal1.form.ref].resetFields()
    this.modal1.show = false
  }
  Update() {
    this.$refs[this.modal1.form.ref].validate(valid => {
      if (valid) {
        let params = { ...this.modal1.form.data }
        delete params._index
        delete params._rowKey

        UpdateAppTagList(params).then(res => {
          this.CloseModal1()
          this.GetList()
        })
      }
    })
  }
  // 复制标签策略
  updateCopy() {
    this.$refs[this.copy_modal.form.ref].validate(valid => {
      if (valid) {
        CopyAppTag({ ...this.copy_modal.form.data }).then(res => {
          this.$refs[this.copy_modal.form.ref].resetFields()
          this.copy_modal.show = false
        })
      }
    })
  }
  //获取策略关联详情
  getGameRiskList(tag, type) {
    if (type == 'risk_tag') {
      this.risk_modal.show = true
      GetGameRiskList({ tag }).then(res => {
        this.risk_modal.table.data = res._param.data || []
      })
    } else if (type == 'smart_tag') {
      this.intelligent_modal.show = true
      GetSmartRiskList({ tag }).then(res => {
        this.intelligent_modal.table.data = res._param.list || []
      })
    }
  }

  rogo(type) {
    if (type == 1) {
      this.risk_modal.show = false
      this.$router.push({
        path: 'gameLibConf/' + this.risk_modal.tag,
        params: {
          tag: this.risk_modal.tag
        }
      })
    } else if (type == 2) {
      this.intelligent_modal.show = false
      this.$router.push({
        path: 'intelligentLibConf/' + this.intelligent_modal.tag,
        params: {
          tag: this.intelligent_modal.tag
        }
      })
    }
  }
  created() {
    this.GetList()
  }
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 270
    console.log('maxHeight: ', this.tableMaxHeight)
  }
}
</script>
<style lang="less" scoped>
</style>
